import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import withBranchHOC from "../Hoc/BranchHOC";
import { BranchRegister } from "./BranchRegister";
import { getGlobalVault } from "../Components/JointApplicant/Actions/JointApplicantAction";
import doRegistration from "../Components/Register/Actions/RegisterAction";
import doCheckExistingUser from "../Components/Register/Actions/ExistingUserActions";
import AppConstants from "../Constants/AppConstants";
import OtpModal from "./OtpModal";
import BranchModal from "./BranchModal";
import doVerificationCodeAction from "../Components/VerificationCode/Actions/VerificationCodeAction";
import {
  HTTP_STATUS,
  S_ACCOUNT_ID,
  S_APPLICANT_ID,
  S_BANKING_TYPE,
  S_CURRENT_MEMBER_ID,
  S_EMAIL,
  S_MSISDN,
} from "../Communication/Constants";
import * as ROUTES from "../Constants/Routes";
import { storeFilterBankingType } from "../Components/MarketPlace/Action/MarketPlaceAction";
import { doConsent } from "../Components/TermsAndConditions/Actions/TermsActions";

class BranchRegisterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOtpModal: false,
      showSuccessModal: false,
      verifyingUser: false,
      registrationData: {},
      otpId: null,
      errors: {
        authCode: null,
      },
    };
  }

  componentDidMount() {
    const { doStoreFilterBankingType } = this.props;
    sessionStorage.setItem(S_BANKING_TYPE, AppConstants.BANKING_TYPE.PERSONAL);
    doStoreFilterBankingType(AppConstants.BANKING_TYPE.PERSONAL);
  }

  // Enhanced registration handler that can trigger OTP verification
  doVerification = (otpData, successCallback, errorCallback) => {
    const { finInfo } = this.props;
    const { registrationData } = this.state;
    if (
      finInfo?.allowOtpOverride &&
      (!registrationData.hasMobile ||
        (registrationData.hasMobile && !registrationData.mobileOnHand))
    ) {
      this.setState(
        {
          showOtpModal: false,
          verifyDisabled: true,
          otpId: otpData.otpId,
          errors: { authCode: null },
        },
        () => this.handleSkipOtp()
      );
    } else {
      this.setState({
        showOtpModal: true,
        verifyDisabled: true,
        otpId: otpData.otpId,
        errors: { authCode: null },
      });
    }
  };

  handleRegister = (otpData, callback) => {
    const { doRegister } = this.props;
    if (!otpData.msisdn) {
      otpData.msisdn = `1${otpData.homePhone}`;
    }
    this.setState({ registrationData: otpData }, () => {
      doRegister(
        {
          ...otpData,
        },
        (response) => {
          callback(response);
        }
      );
    });
  };

  // Handle OTP verification for registration
  handleOtpVerify = (authCode, skipOtp) => {
    const { doVerificationCode } = this.props;
    const { otpId, registrationData } = this.state;

    this.setState({ verifyingUser: true });

    // Submit registration with OTP
    doVerificationCode(
      {
        otp: authCode,
        otpId,
        staffUserRegistration: true,
        override: !!skipOtp,
      },
      (response) => {
        if (response?.status === HTTP_STATUS.OK) {
          console.log("OTP verification successful:", response);
          this.setState({
            showOtpModal: false,
            verifyingUser: false,
            registrationData: null,
            otpId: null,
          });
          sessionStorage.setItem(
            S_CURRENT_MEMBER_ID,
            response.data.data.accountId.toUpperCase()
          );
          sessionStorage.setItem(
            S_ACCOUNT_ID,
            response.data.data.accountId.toUpperCase()
          );
          sessionStorage.setItem(S_EMAIL, registrationData.email);
          sessionStorage.removeItem(S_APPLICANT_ID);
          if (registrationData.msisdn) {
            sessionStorage.setItem(S_MSISDN, registrationData.msisdn);
          } else {
            let homePhone = registrationData.homePhone;
            if (homePhone && homePhone.length === 10) {
              homePhone = `1${homePhone}`;
            }
            sessionStorage.setItem(S_MSISDN, homePhone);
          }
          // Show success modal
          this.setState({ showSuccessModal: true });
        } else {
          this.setState({
            verifyingUser: false,
          });
        }
      },
      (error) => {
        console.error("OTP verification failed:", error);
        this.setState({
          verifyingUser: false,
          errors: {
            authCode: ["Invalid verification code. Please try again."],
          },
        });
      }
    );
  };

  handleSkipOtp = () => {
    this.handleOtpVerify("0000", true);
  };

  // Handle OTP resend for registration
  handleOtpResend = () => {
    const { doRegister } = this.props;
    const { registrationData } = this.state;

    // Resend OTP by re-initiating registration
    doRegister(
      {
        ...registrationData,
        resendOtp: true,
      },
      (response) => {
        console.log("OTP resent successfully");
        if (response.data && response.data.otpId) {
          this.setState({ otpId: response.data.otpId });
        }
      },
      (error) => {
        console.error("Failed to resend OTP:", error);
      }
    );
  };

  toggleOtpModal = (isShow = false) => {
    this.setState({
      showOtpModal: isShow,
      verifyingUser: false,
      errors: { authCode: null },
    });
  };

  toggleSuccessModal = (isShow = false) => {
    const { doConsents } = this.props;
    this.setState(
      {
        showSuccessModal: isShow,
      },
      () => {
        if (!isShow) {
          // Reset state when closing success modal
          doConsents({}, () => {
            const { history } = this.props;
            history.push(`${ROUTES.VAULT_DASHBOARD}?marketplace`);
          });
        }
      }
    );
  };

  render() {
    const {
      finInfo,
      bankingType,
      getGlobalVault: getGlobalVaultProp,
      doCheckExistingUser: doCheckExistingUserProp,
      doRegister,
    } = this.props;

    const {
      showOtpModal,
      showSuccessModal,
      verifyingUser,
      errors,
      verifyDisabled,
    } = this.state;

    return (
      <>
        <BranchRegister
          finInfo={finInfo}
          bankingType={sessionStorage.getItem(S_BANKING_TYPE) || bankingType}
          getGlobalVault={getGlobalVaultProp}
          doCheckExistingUser={doCheckExistingUserProp}
          doRegistration={this.handleRegister}
          doVerification={this.doVerification}
        />
        <OtpModal
          show={showOtpModal}
          onHide={this.toggleOtpModal}
          title="Verification Code"
          description="Enter the code"
          verifyingUser={verifyingUser}
          onVerify={this.handleOtpVerify}
          onResendCode={this.handleOtpResend}
          verifyButtonText="CONTINUE"
          verifyingButtonText="Processing..."
          errors={errors}
          verifyDisabled={verifyDisabled}
          onAuthCodeChange={(authCode) => {
            this.setState({
              verifyDisabled: !authCode,
            });
          }}
        />
        <BranchModal
          show={showSuccessModal}
          onHide={this.toggleSuccessModal}
          title="Success!"
          description="Your customer's marketplace profile has been created successfully."
          buttonText="CONTINUE"
          onButtonClick={() => this.toggleSuccessModal(false)}
          isSuccess
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getGlobalVault,
      doRegister: doRegistration,
      doCheckExistingUser,
      doVerificationCode: doVerificationCodeAction,
      doStoreFilterBankingType: storeFilterBankingType,
      doConsents: doConsent,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  finInfo: state.MarketplaceReducer.finInfo,
  bankingType: state.MarketplaceReducer.bankingType,
});

BranchRegisterContainer.propTypes = {
  finInfo: PropTypes.shape({
    // Add specific properties if known, or use PropTypes.object if structure is unknown
  }),
  bankingType: PropTypes.string, // Replace 'any' with a more specific type if known, e.g., PropTypes.string
  getGlobalVault: PropTypes.func.isRequired,
  doCheckExistingUser: PropTypes.func.isRequired,
  doRegister: PropTypes.func.isRequired,
  doVerificationCode: PropTypes.func.isRequired,
};

BranchRegisterContainer.defaultProps = {
  finInfo: null,
  bankingType: AppConstants.BANKING_TYPE.PERSONAL,
};

const BranchRegisterContainerWithConnect = withBranchHOC(
  BranchRegisterContainer
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BranchRegisterContainerWithConnect);
